(() => {function init(root){if(!root || root.dataset.bmfReady)return;root.dataset.bmfReady='1';
// Preserve ad and creator attribution on the landing-to-product handoff.
const witsRouteParams=new URLSearchParams(location.search);root.querySelectorAll('a[href]').forEach(a=>{const u=new URL(a.href,location.origin);if(u.origin!==location.origin||!u.pathname.startsWith('/products/'))return;for(const [k,v] of witsRouteParams)if(/^(utm_|tm_)/.test(k)||['fbclid','gclid','ttclid','trybe'].includes(k))u.searchParams.set(k,v);a.href=u.href;});

const toggle=root.querySelector('.bz-motion-toggle');const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');function setMotion(paused){root.classList.toggle('motion-paused',paused);toggle.textContent=paused?'Play motion':'Pause motion';toggle.setAttribute('aria-pressed',String(paused));window.dispatchEvent(new Event('wits:motionchange'));}toggle.addEventListener('click',()=>setMotion(!root.classList.contains('motion-paused')));reducedMotion.addEventListener('change',e=>setMotion(e.matches));setMotion(reducedMotion.matches);
(() => {
  const videos = [...root.querySelectorAll('video[data-managed-motion]')];
  const near = new WeakSet(), visible = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let suspended = false;
  let resumeTimers = [];
  const paused = () => root.classList.contains('motion-paused') || reduced.matches || document.hidden || suspended;
  function load(video) {
    if (video.dataset.loaded) return;
    // Safari/iOS need HEVC alpha; Chromium/Firefox use VP9 alpha.
    // Keep one selected source so an opaque HEVC decoder cannot win fallback selection.
    if (video.hasAttribute('data-blender-spin') && video.dataset.appleSrc) {
      const ua = navigator.userAgent;
      const ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const safari = /Apple/.test(navigator.vendor) && !/Chrome|Chromium|Edg|OPR|FxiOS/.test(ua);
      const apple = (ios || safari) && !!video.canPlayType('video/mp4; codecs="hvc1"');
      const mobile = matchMedia('(max-width: 749px)').matches;
      const source = video.querySelector('source');
      const url = apple
        ? (mobile && video.dataset.mobileAppleSrc || video.dataset.appleSrc)
        : (mobile && video.dataset.mobileSrc || source.dataset.src);
      source.src = url;
      source.type = apple ? 'video/mp4; codecs="hvc1"' : 'video/webm';
    } else {
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
    }
    video.dataset.loaded = 'true';
    video.load();
  }
  function sync(video) {
    if (paused() || !visible.has(video)) { video.pause(); return; }
    load(video);
    video.play().catch(() => {}); // Poster stays visible when autoplay is unavailable.
  }
  const loadObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        near.add(entry.target);
        if (!paused()) load(entry.target);
      } else near.delete(entry.target);
    }
  }, {rootMargin:'180px 0px'});
  const playObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRatio > 0.08) visible.add(entry.target);
      else visible.delete(entry.target);
      sync(entry.target);
    }
  }, {threshold:[0,0.08,0.25]});
  videos.forEach(video => {
    video.addEventListener('playing', () => {
      const reveal = () => video.classList.add('v7-ready');
      if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
      else reveal();
    });
    video.addEventListener('error', () => video.classList.remove('v7-ready'));
    video.querySelectorAll('source').forEach(source => source.addEventListener('error', () => video.classList.remove('v7-ready')));
    loadObserver.observe(video); playObserver.observe(video);
  });
  function update() {
    for (const video of videos) {
      if (near.has(video) && !paused()) load(video);
      sync(video);
    }
  }
  // Returning from an iOS app switch does not necessarily produce a new
  // IntersectionObserver entry. Re-measure instead of trusting cached visibility.
  function refreshVisibility() {
    const viewport = window.visualViewport;
    const left = viewport ? viewport.offsetLeft : 0;
    const top = viewport ? viewport.offsetTop : 0;
    const width = viewport ? viewport.width : window.innerWidth;
    const height = viewport ? viewport.height : window.innerHeight;
    for (const video of videos) {
      const r = video.getBoundingClientRect();
      const area = Math.max(0, Math.min(r.right, left + width) - Math.max(r.left, left))
        * Math.max(0, Math.min(r.bottom, top + height) - Math.max(r.top, top));
      if (r.width > 0 && r.height > 0 && area / (r.width * r.height) > 0.08) {
        visible.add(video);
        near.add(video);
      } else visible.delete(video);
    }
  }
  function clearResumeTimers() {
    resumeTimers.forEach(clearTimeout);
    resumeTimers = [];
  }
  function resumePlayback() {
    clearResumeTimers();
    refreshVisibility();
    update();
    if (paused()) return;
    const positions = new Map(videos.map(video => [video, video.currentTime]));
    // WebKit can resume the page before its media pipeline is ready.
    // Retry briefly; never reload the file or run a permanent polling loop.
    for (const delay of [120, 450, 1100, 2200]) {
      resumeTimers.push(setTimeout(() => {
        if (paused()) { clearResumeTimers(); return; }
        refreshVisibility();
        for (const video of videos) {
          if (visible.has(video) && delay >= 1100 && !video.paused
              && video.readyState >= 2 && !video.seeking
              && Math.abs(video.currentTime - positions.get(video)) < 0.01) {
            // A suspended decoder can report "playing" without advancing.
            video.pause();
          }
          positions.set(video, video.currentTime);
        }
        update();
      }, delay));
    }
  }
  function suspendPlayback() {
    suspended = true;
    clearResumeTimers();
    update();
  }
  function returnToPage() {
    if (document.hidden) return;
    suspended = false;
    resumePlayback();
  }
  window.addEventListener('wits:motionchange', resumePlayback);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) suspendPlayback();
    else returnToPage();
  });
  window.addEventListener('pagehide', suspendPlayback);
  window.addEventListener('pageshow', returnToPage);
  window.addEventListener('focus', returnToPage);
  document.addEventListener('freeze', suspendPlayback);
  document.addEventListener('resume', returnToPage);
  reduced.addEventListener('change', resumePlayback);
  // If the OS denied autoplay, a normal touch can resume only these muted
  // decorative loops; explicit Pause motion and reduced-motion stay respected.
  function resumeOnInteraction() {
    if (paused()) return;
    refreshVisibility();
    if (videos.some(video => visible.has(video) && video.paused)) resumePlayback();
  }
  document.addEventListener('touchend', resumeOnInteraction, {passive:true});
  document.addEventListener('pointerup', resumeOnInteraction, {passive:true});
})();

(() => {
 const momentsRoot = root.querySelector('.v10-moments');
 if (!momentsRoot) return;
 const tabs = [...momentsRoot.querySelectorAll('[data-moment-tab]')];
 const moments = Object.fromEntries([...momentsRoot.querySelectorAll('template[data-moment-copy]')].map(t=>[t.dataset.momentCopy,{title:t.content.querySelector('h2').innerHTML,body:t.content.querySelector('p').innerHTML}]));
 function select(tab) {
  const key = tab.dataset.momentTab;
  tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
  momentsRoot.dataset.moment = key;
  momentsRoot.querySelector('#v10-moment-heading').innerHTML = moments[key].title;
  momentsRoot.querySelector('#v10-moment-body').innerHTML = moments[key].body;
  momentsRoot.querySelector('[role=tabpanel]').hidden = false;
  momentsRoot.querySelector('[role=tabpanel]').setAttribute('aria-labelledby', tab.id);
 }
 tabs.forEach((tab, i) => {
  tab.addEventListener('click', () => select(tab));
  tab.addEventListener('keydown', e => {
   let next;
   if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
   if (e.key === 'ArrowLeft') next = tabs[(i + tabs.length - 1) % tabs.length];
   if (e.key === 'Home') next = tabs[0];
   if (e.key === 'End') next = tabs[tabs.length - 1];
   if (next) { e.preventDefault(); select(next); next.focus(); }
  });
 });
 const videos = [...momentsRoot.querySelectorAll('.v10-video-frame video')];
 videos.forEach(video => video.addEventListener('play', () => videos.forEach(other => { if (other !== video) other.pause(); })));
 document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(v => v.pause()); });
})();

(() => {
  root.querySelectorAll('.v11-video-start').forEach(button => {
    const frame = button.closest('.v10-video-frame');
    const video = frame.querySelector('video');
    const status = frame.querySelector('.v11-video-status');
    const surface = document.createElement('button');
    surface.type = 'button';
    surface.className = 'v15-video-surface';
    surface.hidden = true;
    surface.setAttribute('aria-label', 'Pause video');
    surface.innerHTML = '<span aria-hidden="true">▶</span>';
    frame.append(surface);
    const syncSurface = () => {
      surface.hidden = video.hidden;
      surface.setAttribute('aria-label', video.paused ? 'Resume video' : 'Pause video');
      surface.classList.toggle('is-paused', video.paused);
    };
    surface.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => { status.hidden = false; });
      else video.pause();
    });
    let controlsTimer;
    let interacting = false;
    const fullscreen = () => video.webkitDisplayingFullscreen ||
      video.webkitPresentationMode === 'fullscreen' ||
      document.fullscreenElement === video || document.fullscreenElement === frame;
    const revealControls = () => {
      clearTimeout(controlsTimer);
      video.controls = true;
    };
    const hideControlsSoon = () => {
      revealControls();
      if (video.paused || video.ended || video.seeking || interacting || fullscreen()) return;
      controlsTimer = setTimeout(() => {
        if (!video.paused && !video.ended && !video.seeking && !interacting && !fullscreen()) {
          video.controls = false;
        }
      }, 500);
    };
    ['play', 'pause', 'ended'].forEach(event => video.addEventListener(event, syncSurface));
    ['playing', 'seeked'].forEach(event => video.addEventListener(event, hideControlsSoon));
    ['pause', 'ended', 'waiting', 'seeking', 'error'].forEach(event => video.addEventListener(event, revealControls));
    video.addEventListener('pointerdown', () => { interacting = true; revealControls(); });
    ['pointerup', 'pointercancel'].forEach(event => window.addEventListener(event, () => {
      if (!interacting) return;
      interacting = false;
      hideControlsSoon();
    }));
    video.addEventListener('click', hideControlsSoon);
    video.addEventListener('webkitbeginfullscreen', revealControls);
    video.addEventListener('webkitendfullscreen', hideControlsSoon);
    video.addEventListener('webkitpresentationmodechanged', hideControlsSoon);
    document.addEventListener('fullscreenchange', hideControlsSoon);
    video.addEventListener('keydown', event => {
      if (!video.controls && (event.key === ' ' || event.key === 'Enter')) {
        event.preventDefault();
        if (video.paused) video.play().catch(() => { status.hidden = false; });
        else video.pause();
      }
    });
    button.addEventListener('click', () => {
      status.hidden = true;
      if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
      video.hidden = false;
      syncSurface();
      button.hidden = true;
      video.play().then(() => video.focus()).catch(() => {
        button.hidden = false;
        video.hidden = true;
        syncSurface();
        status.hidden = false;
      });
    });
    video.addEventListener('error', () => {
      button.hidden = false;
      video.hidden = true;
      syncSurface();
      status.hidden = false;
    });
  });
})();

(() => {
  const track = root.querySelector('.v10-video-grid');
  if (!track) return;
  const cards = [...track.querySelectorAll('.v10-video-card')];
  const videos = cards.map(card => card.querySelector('video'));
  const prev = root.querySelector('.v20-video-prev');
  const next = root.querySelector('.v20-video-next');
  const count = root.querySelector('.v20-video-count');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let current = 0, settling, centering = false, centerTimer;
  function nearest() {
    const middle = track.getBoundingClientRect().left + track.clientWidth / 2;
    return cards.reduce((best, card, i) => {
      const rect = card.getBoundingClientRect();
      const other = cards[best].getBoundingClientRect();
      return Math.abs(rect.left + rect.width / 2 - middle) < Math.abs(other.left + other.width / 2 - middle) ? i : best;
    }, 0);
  }
  function update(i) {
    current = i;
    cards.forEach((card, n) => card.classList.toggle('is-current', n === i));
    prev.disabled = i === 0;
    next.disabled = i === cards.length - 1;
    count.textContent = `${i + 1} / ${cards.length}`;
  }
  function center(i, alignPage = false, instant = false) {
    if (matchMedia("(min-width:1000px)").matches) { track.scrollLeft = 0; return; }
    clearTimeout(centerTimer);
    centering = true;
    update(i);
    const rect = cards[i].getBoundingClientRect();
    const viewport = track.getBoundingClientRect();
    const behavior = instant || reduced.matches ? 'instant' : 'smooth';
    track.scrollTo({left: track.scrollLeft + rect.left - viewport.left - (track.clientWidth - rect.width) / 2, behavior});
    if (alignPage) window.scrollTo({top: Math.max(0, window.scrollY + rect.top - (window.innerHeight - rect.height) / 2), behavior});
    centerTimer = setTimeout(() => { centering = false; }, 650);
  }
  function navigate(i) {
    videos.forEach(video => video.pause());
    center(Math.max(0, Math.min(cards.length - 1, i)));
  }
  prev.addEventListener('click', () => navigate(current - 1));
  next.addEventListener('click', () => navigate(current + 1));
  track.addEventListener('keydown', e => {
    if (e.target !== track) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault(); navigate(current + (e.key === 'ArrowRight' ? 1 : -1));
    }
  });
  videos.forEach((video, i) => video.addEventListener('play', () => {
    videos.forEach(other => { if (other !== video) other.pause(); });
    center(i, true);
  }));
  track.addEventListener('scroll', () => {
    clearTimeout(settling);
    settling = setTimeout(() => {
      if (centering || matchMedia("(min-width:1000px)").matches) return;
      const i = nearest();
      videos.forEach((video, n) => { if (n !== i) video.pause(); });
      update(i);
    }, 140);
  }, {passive:true});
  window.addEventListener('resize', () => center(current, false, true));
  requestAnimationFrame(() => center(0, false, true));
})();

}document.querySelectorAll('.wits-bmf').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.wits-bmf')));})();